import { Z_INDEX } from '@/config/z-index';
import { CHART_GRID_COLOR } from '@/features/_shared/chart/hooks/options/useChartFunctions';

import type Highcharts from 'highcharts/highstock';
import type { Theme } from '@/shared/ui';

const getRegularTooltip = (
  createTooltipFormatter: (
    allChartSeries: Highcharts.Series[],
    hoveredPointXValue: string | number | undefined
  ) => string,
  theme: Theme
) => {
  const tooltip: Highcharts.TooltipOptions = {
    positioner(labelWidth, labelHeight, point) {
      const chart = this.chart;
      let x = point.plotX + chart.plotLeft - labelWidth / 2;
      let y = point.plotY + chart.plotTop - labelHeight - 10;

      const chartWidth = chart.plotWidth;

      if (x < chart.plotLeft) {
        x = chart.plotLeft;
      } else if (x + labelWidth > chart.plotLeft + chartWidth) {
        x = chart.plotLeft + chartWidth - labelWidth;
      }

      if (y < chart.plotTop) {
        y = point.plotY + chart.plotTop + 10;
      }

      return { x, y };
    },
    formatter(): string {
      const allChartSeries = this.series.chart.series;
      const hoveredPointXValue = this.x;
      return createTooltipFormatter(allChartSeries, Number(hoveredPointXValue));
    },
    outside: true,
    className: 'tooltip-regular-chart',
    enabled: true,
    split: false,
    followPointer: true,
    backgroundColor: CHART_GRID_COLOR,
    borderRadius: 0,
    useHTML: true,
    style: {
      zIndex: Z_INDEX.chartOverlay,
      color: theme.palette.gx.text,
      fontFamily: 'Cairo, sans-serif'
    }
  };

  return { tooltip };
};

export default getRegularTooltip;
